import React, { useState, useEffect } from "react";
import "./WelcomeModal.css";
import { useNavigate } from "react-router-dom";

const WelcomeModal = ({
  isOpen,
  role,
  userData,
  buttons = {
    primary: "",
    primaryAction: () => {},
    secondary: "",
    secondaryAction: () => {},
  },
  isProcessing,
  pendingInterestData,
}) => {
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const navigate = useNavigate();
  const allChecked = termsChecked && privacyChecked;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    if (isOpen && pendingInterestData) {
      console.log(
        "🎉 WelcomeModal: Pending interest detected:",
        pendingInterestData,
      );
    }
  }, [isOpen, pendingInterestData]);

  const title =
    role === "guest"
      ? "Welcome to NimbleBash (Guest)"
      : role === "host"
        ? "Welcome to NimbleBash (Host)"
        : "Welcome to NimbleBash (Usher)";

  const subtitle =
    role === "guest"
      ? "NimbleBash: A place for all guests"
      : role === "host"
        ? "NimbleBash: A place for all hosts"
        : "NimbleBash: A place for all ushers";

  const description =
    role === "guest"
      ? "Below are great advantages of using NimbleBash Mobile App as a guest:"
      : role === "host"
        ? "Below are great advantages of using NimbleBash Mobile App to manage your event:"
        : "Below are great advantages of using NimbleBash Mobile App as an usher:";

  const features =
    role === "guest"
      ? [
          { text: "You can make payment for Event Attire, etc." },
          { text: "You can donate cash gift to support the event host." },
          {
            text: "You will have a digital entrance card into the event venue.",
          },
        ]
      : role === "host"
        ? [
            { text: "Create NimbleBash Event." },
            { text: "Send invites to guests." },
            { text: "Download curated list of invited guests." },
            { text: "Receive Event Attire, etc payments with ease." },
          ]
        : [
            { text: "View and manage assigned event tasks." },
            { text: "Validate guest entrance with digital cards or QR codes." },
            { text: "Assist the host in ensuring smooth event flow." },
          ];

  if (!isOpen) return null;

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal-container">
        <div className="welcome-modal-content">
          <div className="welcome-container">
            <h1 className="welcome-modal-title">{title}</h1>

            <div className="welcome-modal-image-wrapper">
              <img
                src="/images/onboarding-page-image.webp"
                alt="NimbleBash illustration"
              />
            </div>

            <div className="welcome-modal-subtitle">{subtitle}</div>

            {pendingInterestData && (
              <div className="welcome-modal-event-context">
                <div className="welcome-modal-event-icon">🎉</div>
                <div className="welcome-modal-event-text">
                  <strong>You're signing up to attend:</strong>
                  <p>{pendingInterestData.eventTitle}</p>
                </div>
              </div>
            )}

            <div className="welcome-modal-description">{description}</div>

            <ul className="welcome-modal-features">
              {features.map((feature, index) => (
                <li key={index}>{feature.text}</li>
              ))}
            </ul>

            <p className="welcome-modal-policy-text">
              Before you continue, please accept our policies
            </p>

            <div className="welcome-modal-checkboxes">
              <label className="welcome-modal-item">
                <input
                  type="checkbox"
                  checked={termsChecked}
                  onChange={(e) => setTermsChecked(e.target.checked)}
                />
                <span className="welcome-modal-item-container">
                  <span className="welcome-modal-agree">I agree to the </span>
                  <a
                    href="/terms-and-conditions"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="welcome-modal-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Terms & Conditions
                  </a>
                </span>
              </label>

              <label className="welcome-modal-item">
                <input
                  type="checkbox"
                  checked={privacyChecked}
                  onChange={(e) => setPrivacyChecked(e.target.checked)}
                />
                <span>
                  <span className="welcome-modal-agree">I agree to the </span>
                  <a
                    href="/privacy-policy"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="welcome-modal-link"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Privacy Policy
                  </a>
                </span>
              </label>
            </div>

            <div className="welcome-modal-joint-buttons">
              <button
                className="welcome-modal-back-button"
                onClick={buttons.secondaryAction}
                disabled={isProcessing}
              >
                Back
              </button>

              <button
                className="welcome-modal-confirm-btn"
                disabled={!allChecked || isProcessing}
                onClick={buttons.primaryAction}
              >
                {isProcessing ? "Please wait..." : "Yes, I understand"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;